import React from 'react';
import { curry, get } from 'lodash';
import { Query } from 'react-apollo';
import { omit } from 'lodash/fp';

import { defaultAsset } from '../constants';

import query from './caseRequestAssetsQuery';

const clearTypeName = omit('__typename');

export const buildQueryChild = curry(
  (WrapperComponent, componentProps, { data, loading }) => {
    const caseId = get(data, 'case.id');
    const primaryAsset = get(data, 'case.primaryAsset') || defaultAsset;
    const caseRelatedAssets = get(data, 'case.relatedAssets', []);

    const relatedAssets = [0, 1].map(index =>
      clearTypeName(caseRelatedAssets[index] || defaultAsset),
    );

    return (
      <WrapperComponent
        {...componentProps}
        caseId={caseId}
        primaryAsset={clearTypeName(primaryAsset)}
        relatedAssets={relatedAssets}
        isLoadingAssets={!!loading}
      />
    );
  },
);

const withRequestAssets = WrappedComponent => componentProps => (
  <Query
    skip={!componentProps.caseNumber}
    query={query}
    variables={{ caseNumber: componentProps.caseNumber }}
  >
    {buildQueryChild(WrappedComponent, componentProps)}
  </Query>
);

export default withRequestAssets;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/RequestAssetsForm/withRequestAssets/index.js